import React, { useEffect, useMemo, useState } from 'react';
import { Card, Form, Select, Input, Button, Space, message, InputNumber, Tag } from 'antd';
import request from '../../../utils/request';

const CreateInternalWorkOrderPage: React.FC = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [tplOptions, setTplOptions] = useState<Array<{ value: number; label: string }>>([]);
  const [warehouseOptions, setWarehouseOptions] = useState<Array<{ value: number; label: string }>>([]);
  const [tplLoading, setTplLoading] = useState(false);
  const [whLoading, setWhLoading] = useState(false);

  const loadInternalTemplates = async () => {
    setTplLoading(true);
    try {
      // 拉取 internal 模板
      const resp = await request.get('/api/v1/workorders/workorder-templates/', { params: { category: 'internal', is_active: 1, page_size: 200 } });
      const rows = Array.isArray(resp?.data?.results) ? resp.data.results : (Array.isArray(resp?.data) ? resp.data : []);
      setTplOptions(rows.map((r:any)=> ({ value: Number(r.id), label: `${r.name || r.code || r.id} · ${r.code || ''}` })));
    } catch {
      setTplOptions([]);
    } finally { setTplLoading(false); }
  };

  const loadWarehouses = async () => {
    setWhLoading(true);
    try {
      const resp = await request.get('/api/v1/warehouse/warehouses/', { params: { page_size: 200 } });
      const rows = Array.isArray(resp?.data?.results) ? resp.data.results : (Array.isArray(resp?.data) ? resp.data : []);
      setWarehouseOptions(rows.map((w:any)=> ({ value: Number(w.id), label: `${w.name || ''} · ${w.code || w.id}` })));
    } catch {
      setWarehouseOptions([]);
    } finally { setWhLoading(false); }
  };

  useEffect(() => { loadInternalTemplates(); loadWarehouses(); }, []);

  const submit = async () => {
    let v:any;
    try { v = await form.validateFields(); } catch { return; }
    setLoading(true);
    try {
      const payload:any = {
        template: Number(v.template_id),
        warehouse_id: Number(v.warehouse_id),
        priority: v.priority || 'normal',
        remarks: v.remarks || '',
      };
      await request.post('/api/v1/workorders/workorders/create_internal/', payload);
      message.success('已创建内部工单');
      form.resetFields();
    } catch (e:any) {
      message.error(e?.response?.data?.message || e?.response?.data?.detail || '创建失败');
    } finally { setLoading(false); }
  };

  return (
    <div className="p-4">
      <Card title="创建仓内工单（Internal）" bordered>
        <Form form={form} layout="vertical" initialValues={{ priority: 'normal' }}>
          <Space size={16} style={{ display: 'flex' }}>
            <Form.Item name="template_id" label="运维工单模板" rules={[{ required: true, message: '请选择运维工单模板' }]}>
              <Select style={{ width: 420 }} showSearch placeholder="选择模板（仅显示 category=internal）" loading={tplLoading} options={tplOptions} />
            </Form.Item>
            <Form.Item name="warehouse_id" label="仓库" rules={[{ required: true, message: '请选择仓库' }]}>
              <Select style={{ width: 360 }} showSearch placeholder="选择仓库" loading={whLoading} options={warehouseOptions} />
            </Form.Item>
            <Form.Item name="priority" label="优先级">
              <Select style={{ width: 180 }} options={[
                { value: 'normal', label: '普通' },
                { value: 'high', label: '一般优先' },
                { value: 'super', label: '超级优先' },
              ]} />
            </Form.Item>
          </Space>
          <Form.Item name="remarks" label="备注（可选）">
            <Input.TextArea rows={3} placeholder="请输入工单备注" />
          </Form.Item>
          <div style={{ margin: '8px 0 16px 0', padding: '6px 8px', background: '#e6f4ff', border: '1px solid #91caff', borderRadius: 4, color: '#0958d9' }}>
            说明：仅允许使用“仓内运维”类模板（category=internal）创建内部工单；该类工单与客户指令无关，不计入客户账单（若模板为非计费或系统策略跳过计费时）。
          </div>
          <Space>
            <Button type="primary" loading={loading} onClick={submit}>创建工单</Button>
            <Button onClick={() => form.resetFields()}>重置</Button>
          </Space>
        </Form>
      </Card>
    </div>
  );
};

export default CreateInternalWorkOrderPage;


